import api from '@/api';

export default {
  scoreConsumidor: (action, orderId = '') => api.post('/consumer_score', { action, orderId }),
};
